module.exports = __webpack_public_path__ + "img/noavailabilities.43ee292c.png";